import { makeStyles } from '@material-ui/core';
import React from 'react';
import styled from 'styled-components';
import { Card, Grid } from '@material-ui/core';

export const useStyles = makeStyles({
  root: {
    fontSize: '11px !important',
    border: '1px solid #E6E6E6',
    borderRadius: '6px',
    width: '98px !important',
    color: '#172C51 !important',
    '&:hover': {
      color: '#172C51 !important',
    },
  },
});
export const StyledCard = styled(({ ...otherProps }) => (
  <Card {...otherProps} />
))`
  background-color: #fff !important;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.15) !important;
  border-radius: 8px !important;
  height: 164px !important;
  justify-content: center !important;
  align-items: center !important;
`;
export const StyledGrid = styled(
  ({ textAlign, marginBottom, ...otherProps }) => <Grid {...otherProps} />,
)`
  text-align: ${(props) => props.textAlign} !important;
  margin-bottom: ${(props) => props.marginBottom} !important;
  min-height: 150px !important;
`;
